import { Tab, Box, Tabs, Paper, Chip, Grid } from '@mui/material';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import InspectionCardHeader from './inspection-card-header';
import PoliciesFaqs from '../policies-faqs';
import KeyValueReport from './key-value-report';
import PartSubpartReport from './part-subpart-report';
import { isValidArray } from '../../../utils/is-array';
import { prepareGADataAndSendEvent } from '../../../tracking';

// Icons
import { ExpandMore as ExpandMoreIcon } from '@mui/icons-material';
import { ReactComponent as CheckedCircle} from './check_circle.svg';
import { ReactComponent as Info } from './info.svg';

let isClicked = false;
const InspectionReport = ({ user, auction, isMyCarsSection, handleImageOpen }) => {
    const [value, setValue] = useState(1);
    const [showHeader, setShowHeader] = useState(false);
    const headerRef = useRef();
    const refValue = useRef(1);
    const { inspectionReport, appointmentId } = auction || {};
    const [offsetValues, setOffsetValues] = useState({});
    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showHeader, value]);
    useEffect(() => {
        if (isValidArray(inspectionReport)) {
            const offsetFromReport = {};
            inspectionReport.forEach((v, i) => {
                offsetFromReport[i + 1] = 0;
            });
            const keys = Object.keys(offsetFromReport);
            const cloned = { ...offsetFromReport };
            keys.map(xx => {
                const ele = document.getElementById(xx);
                cloned[xx] = ele?.offsetTop + ele?.offsetHeight + ele?.offsetParent?.offsetTop - 200;
                return xx;
            });
            setOffsetValues({ ...cloned });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inspectionReport]);

    useEffect(() => {
        if (showHeader || (showHeader && !value)) {
            prepareGADataAndSendEvent('inspectionReportView', user, auction, 'Inspection report', { index: value, eventLabel: isValidArray(tabs) && tabs.find(v => v.key === value)?.title });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, showHeader]);

    const handleScroll = () => {

        // Rendering the header card
        const headerElementPosition = headerRef?.current?.offsetParent?.offsetTop - 60;
        if (headerElementPosition <= window.scrollY) {
            setShowHeader(true);
        } else if (showHeader) {
            setShowHeader(false);
        }

        // Shifting each tabs along with tab cards navigation
        if (window.scrollY < offsetValues[refValue.current] && refValue.current > 1 && !isClicked) {
            refValue.current -= 1;
            setValue(b => b - 1);
        } if (window.scrollY > offsetValues[refValue.current] && refValue.current > 0 && !isClicked && refValue.current < inspectionReport?.length) {
            setValue(b => b + 1);
            refValue.current += 1;
        }
    };

    const handleChange = (event, newValue) => {
        event.preventDefault();
        setValue(newValue);
        refValue.current = newValue;
        const domElement = document.getElementById(newValue);
        const y = domElement.getBoundingClientRect().top + window.scrollY - 125;
        isClicked = true;
        window.scroll({
            top: y,
            behavior: 'smooth'
        });
        setTimeout(() => {
            isClicked = false;
        }, 1000);
    };

    const tabs = inspectionReport?.map((tab, idx) => ({ title: tab?.title, key: idx + 1 })) || [];
    const isKeyValueReport = (key) => {
        const flag = ['basicDetails', 'specsAndFeatures', 'warrantyDetails', 'looseItems', 'serviceHistoryDetails'].includes(key);
        return flag;
    };

    const handleClick = (title) => {
        prepareGADataAndSendEvent( 'accordionClick', user, auction, 'Inspection report',  { eventLabel: title });
    };
    return (
        <div ref={headerRef}>
            <Paper sx={{ width: '100%', background: 'transparent' }} elevation={0}>
                {showHeader && <InspectionCardHeader auction={auction} isMyCarsSection={isMyCarsSection} />}
                <Box sx={{ border: 1, borderBottom: 0, top: '5.7rem' }} className='bg-white overflow-hidden sticky z-10 rounded-t-lg border-border'>
                    <Tabs
                        variant="scrollable"
                        value={value}
                        scrollButtons={true}
                        allowScrollButtonsMobile
                        classes={{ root: 'inspection-report-tab h-16', scrollButtons: 'ip-scroll-btn w-8' }}
                        onChange={handleChange}
                        aria-label="lab API tabs example"
                    >
                        {tabs.map(({ key, title }, index) => (
                            <Tab key={index} label={title} value={key} classes={{ selected: `bg-tab-bg ${index === 0 && 'rounded-tl-lg'}`, root: 'font-bold px-3 min-w-max h-16' }} />
                        ))}
                    </Tabs>
                </Box>
                {inspectionReport?.map(({ child, title, key, redCount, greenCount }, index) => (
                    <div key={index} id={index + 1} className='z-10 bg-white rounded-md'>
                        <Box className={`bg-white border-border rounded-md ${index === 0 ? 'rounded-t-none' : ''}`} sx={{ border: 1, margin: '.5em 0', marginTop: `${index === 0 ? '0!important' : ''}` }}>
                            <Accordion
                                key={`inspection_report_${key}`}
                                defaultExpanded={key === 'basicDetails'}
                                disableGutters={true}
                                onClick={handleClick.bind(null, title)}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    id="panel-header"
                                >
                                    <Grid container justifyContent={'space-between'} spacing={0} >
                                        <Grid item>
                                            <div>
                                                <span className='text-lg font-bold inline-block'>{title}</span>
                                            </div>
                                        </Grid>
                                        {!['specsAndFeatures', 'looseItems']?.includes(key) && <Grid item className={'mt-1'} >
                                            <span className={`flex text-center justify-center mr-2`} >
                                                {!!greenCount && <>
                                                    <span className='ml-2'><CheckedCircle className='h-5 w-5 text-success mr-2'/></span>
                                                    {greenCount}
                                                </>}
                                                {!!redCount && <>
                                                    <span className='ml-2'><Info className='h-5 w-5 text-success mr-2'/></span>
                                                    {redCount}
                                                </>}
                                            </span>
                                        </Grid>}
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {child.map((v, idx) => (
                                        <React.Fragment key={idx}>
                                            {
                                                isKeyValueReport(key) ? <KeyValueReport reportData={v} /> :
                                                    <PartSubpartReport reportData={v} notLastItem={idx + 1 < child.length} handleImageOpen={handleImageOpen} />
                                            }
                                        </React.Fragment>
                                    ))}
                                </AccordionDetails>
                            </Accordion>
                        </Box>
                    </div>
                ))}
                <PoliciesFaqs />
                <div className='flex justify-end w-full h-20 my-4 font-bold'>
                    <Chip className='rounded-none' label={`App id: ${appointmentId}`} />
                </div>
            </Paper>
        </div>
    );
};

InspectionReport.propTypes = {
    user: PropTypes.object,
    auction: PropTypes.object,
    isMyCarsSection: PropTypes.bool,
    handleImageOpen: PropTypes.func
};

export default InspectionReport;
